import { Helmet } from 'react-helmet-async';
// remove unused lodash import
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import {
  Card,
  Table,
  Stack,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Button,
} from '@mui/material';

import { getToken } from '../utils/common';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';

import { UserListHead, AlertListToolbar } from '../sections/@dashboard/user';

import USERLIST from '../_mock/alert';

const TABLE_HEAD = [
  { id: 'acc', label: 'Alert Id', alignRight: false },
  { id: 'name', label: 'File Name', alignRight: false },
  { id: 'dataset', label: 'Dataset', alignRight: false },
  { id: 'Amount', label: 'Type', alignRight: false },
  { id: 'numberOfChanges', label: 'Number Of Changes', alignRight: false },
  { id: 'time', label: 'Date & Time', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'Aksi', label: 'Aksi  ', alignRight: false },
];

// removed unused sorting/filtering helpers

export default function UserPage() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);
  const [total, settotal] = useState(1);
  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [data, setData] = useState('');
  const [data2, setData2] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n, _i) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const navigate = useNavigate();

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(Number.parseInt(event.target.value, 10));
    fetchInfo(`${globalThis.REACT_APP_API_PURE}alert/list?limit=${Number.parseInt(event.target.value, 10)}`);
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
    fetchInfo(`${globalThis.REACT_APP_API_PURE}alert/list?alert_name=${event.target.value}`);
  };

  const handleClicker = () => {
    navigate('/dashboard/alertdetail', { replace: true });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const fetchInfo = (url) =>
    fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setData(d);
        settotal(d.total);
      });

  const url2 = `${globalThis.REACT_APP_API_PURE}reference/list?kode=F003`;

  const fetchInfo2 = () =>
    fetch(url2, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setData2(d);
      });
  useEffect(() => {
    fetchInfo(`${globalThis.REACT_APP_API_PURE}alert/list`);
    fetchInfo2();
  }, []);

  return (
    <>
      <Helmet>
        <title> Alert Management | COVAS </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Alert
          </Typography>
        </Stack>

        <Card>
          <AlertListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {data?.data?.map((index, row) => {
                    const channel2 = data2?.data?.find((val) => val.id === index.channel);

                    const dateString = moment.unix(index.created_at).format('YYYY-MM-DD HH:mm');

                    const parts = index?.alert_id.split('-');
                    const firstPart = parts[0] || '';
                    const secondPart = parts[1] || '';

                    return (
                      <TableRow hover key={index?.id ?? row}>
                        <TableCell component="th" scope="row" alignItems="center">
                          {row + 1}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {index.id.split('-').pop()}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {index.name}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {channel2?.label || ''}
                          {index.type}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {firstPart}-{secondPart}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="right">
                          {index.severity}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {dateString}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          <span
                            style={{
                              backgroundColor:
                                index.status === 'Open'
                                  ? 'red'
                                  : index.status === 'Process'
                                  ? 'orange'
                                  : index.status === 'Pending Approval'
                                  ? 'blue'
                                  : 'green',
                              fontSize: 15,

                              color: 'white',
                              borderRadius: 10,
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: 150,
                            }}
                          >
                            {index.status === 'Process' ? 'In Progress' : index.status}
                          </span>
                        </TableCell>

                        <TableCell>
                          <Button variant="outlined" size="small" style={{ borderRadius: 20 }}>
                            Detail
                          </Button>
                          {}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              p: 1,
              width: 140,
              '& .MuiMenuItem-root': {
                px: 1,
                typography: 'body2',
                borderRadius: 0.75,
              },
            },
          },
        }}
      >
        <MenuItem onClick={handleClicker}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Process
        </MenuItem>
      </Popover>
    </>
  );
}
